export const getBuyFilter = state => state.buyReport.filter
